<template>
  <SrpModal v-model:isVisible="isVisible" size="large">
    <template #content>
      <div class="image-selection-debug">
        <!-- <h1 class="global-h1 image-selection-debug__title">AI Image Selection Debug</h1> -->

        <div class="image-selection-debug__section">
          <h4 class="global-h4 image-selection-debug__section-title">Used {{ (props.debugData?.debugInfo?.context || "<model unknown>") + ` from ${props.debugData?.imagesInputForDebug?.length} images` }}</h4>
          <p class="image-selection-debug__caption">{{ props.debugData?.debugInfo?.caption || "No caption generated." }}</p>
        </div>

        <div class="image-selection-debug__section">
          <!-- <h4 class="global-h4 image-selection-debug__section-title">Selected Images</h4> -->
          <ul v-if="props.debugData?.debugInfo?.imagesSelected?.length" class="image-selection-debug__image-list">
            <li v-for="item in props.debugData.debugInfo.imagesSelected" :key="item.index" class="image-selection-debug__image-item">
              <MediaThumbnail class="image-selection-debug__thumbnail" :media-url="item.filename" :fancyboxKey="'ImageSelectionDebug-' + item.filename" />
              <div class="image-selection-debug__image-info">
                <span class="image-selection-debug__image-index">Index: {{ item.index }}</span>
                <p class="image-selection-debug__image-reason">Reason: {{ item.reason }}</p>
              </div>
            </li>
          </ul>
          <p v-else>No images selected.</p>
        </div>

        <div class="image-selection-debug__section">
          <SrpButton color="gray" fill="outlined" @click="showInputPrompt = !showInputPrompt">
            {{ showInputPrompt ? 'Hide' : 'Show' }} Input Prompt
          </SrpButton>
          <div v-if="showInputPrompt" class="image-selection-debug__input-prompt">
            <h4 class="global-h4 image-selection-debug__section-title">Input Prompt</h4>
            <p class="image-selection-debug__caption">{{ props.debugData?.inputPromptForDebug || "No input prompt available." }}</p>
          </div>
        </div>
      </div>
    </template>

    <template #footer>
      <SrpButton color="gray" fill="outlined" @click="isVisible = false">Close</SrpButton>
    </template>
  </SrpModal>
</template>

<script setup lang="ts">
import { ref } from "vue";

// Components
import SrpModal from "@components/ui/SrpModal.vue";
import SrpButton from "@components/ui/SrpButton.vue";
import MediaThumbnail from "@components/MediaThumbnail.vue"; // Assuming this component is suitable

// Types
import { ImageSelectAIDebugData } from "@contracts/shareStop";

// Global variables
const contentBaseUri = globalThis.Bootstrap.Config.contentCdnBaseUri;

const props = defineProps<{
  debugData: ImageSelectAIDebugData | null;
}>();

// Modal visibility state
const isVisible = ref<boolean>(false);
const showInputPrompt = ref<boolean>(false);

// Expose methods to control the modal
defineExpose({
  openModal: () => (isVisible.value = true),
  closeModal: () => (isVisible.value = false),
});
</script>

<style scoped lang="scss">
.image-selection-debug {
  &__title {
    margin-bottom: 20px;
  }

  &__section {
    //padding-bottom: 15px;
    margin-bottom: 15px;
    // border-bottom: 1px solid rgba(0, 0, 0, 0.1);

    &:last-child {
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 0;
    }
  }

  &__section-title {
    margin-bottom: 10px;
  }

  &__caption {
    border: 1px solid #eee;
    padding: 10px;
    border-radius: 4px;
    // font-style: italic;
    color: #555;
    white-space: pre-wrap; // Preserve formatting
  }

  &__image-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: grid;
    gap: 15px;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); // Responsive grid
  }

  &__image-item {
    border: 1px solid #eee;
    border-radius: 4px;
    padding: 10px;
    background-color: #f9f9f9;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__thumbnail {
    width: 100%;
    height: 120px; // Adjust height as needed
    object-fit: cover;
    border-radius: 3px;
  }

  &__image-info {
    font-size: 0.9em;
  }

  &__image-index {
    font-weight: bold;
    display: block;
    margin-bottom: 4px;
  }

  &__image-reason {
    margin: 0;
    color: #333;
  }

  &__input-prompt {
    margin-top: 15px;
  }
}
</style>
